// const hostname = window.location.hostname;

// let stage = "uat"; // kept for potential future use

// switch (hostname) {
//   case "localhost":
//     stage = "dev";
//     break;
//   case "adsdev.lumimatrimony.com":
//     stage = "dev";
//     break;
//   case "adsuat.lumimatrimony.com":
//     stage = "uat";
//     break;
//   case "ads.lumimatrimony.com":
//     stage = "prod";
//     break;
//   default:
//     stage = "dev";
// }

// export const BASE_URL = `/${stage}/v1`;
export const BASE_URL = `/bureau`;

const UserId = JSON.parse(localStorage.getItem('userDetails'))?.id;
console.log('UserId', UserId);
export const API_ENDPOINTS = {
    BASE_URL,
    AUTH: {
        LOGIN: `/auth/login`,
        VERIFY_OTP: '/auth/verify/otp',
        VALIDATE_GST: '/validateGst',
        PAN_VERIFICATION: '/panVerification'
    },

    USER: {
        DATA: '/accessContact'
    },
    VIEW: {
        DATA: '/viewContact'
    },
    TRANSACTION: {
        GET_ALL: `${BASE_URL}/get/transactions`
    },
    DASHBOARD: {
        GET: `${BASE_URL}/dashboard/get?status=active`
    },
    ADS: {
        GET_ALL: `/profile`,
        GET_INDIVIDUAL_AD: `${BASE_URL}/get/ad`,
        ADD: `${BASE_URL}/ad`,
        UPDATE: `${BASE_URL}/update/ad`,
        GET_AD_PLAN: `${BASE_URL}/plan/all`,
        CREATE_AD: `${BASE_URL}/ad`
    },
    ANALYTICS: {
        GET: `/analytics`,
        COUNT: `/analytics/count`,
        ACCESS_CONTACT: 'analytics/access-contact',
        VIEW_CONTACT: 'analytics/view-contact'
    },
    BUSINESS_INFO: {
        CATEGORIES: '/business/category/all',
        GET: `${BASE_URL}`,
        CREATE: `${BASE_URL}/create`,
        UPDATE: `${BASE_URL}/update`
    },
    MOBILE_VIEW: {
        DASHBOARD: `${BASE_URL}/mobile/view/dashboard?sentAd=true`,
        LISTING: `/upload/profile-listing/preview`
    },
    NOTIFICATION: {
        GET: `/notification`,
        UNREAD_COUNT: `/notification/unread/count`
    },
    UPDATE_PHONE: {
        CHANGE_PHONE: '/auth/change-phone',
        VERIFY_PHONE_CHANGE: '/auth/verify-phone-change'
    },
    PAYMENT: {
        GET: '/generate/invoice?transactionId=',
        GATEWAY: '/get/backend/config'
    },
    GET_STATE: '/state/list',
    PROFILE: {
        CREATE: '/profile/create',
        UPDATE: (id) => `/profile/${id}`,
        GET: (id) => `/profile/${id}`,
        DELETE: (id) => `/profile/${id}`,
        CONFIRM: (id) => `/profile/${id}/confirm`,
        EDIT: (id) => `/profile/${id}`,
        DISABLE: (id) => `/profile/${id}/disable`
    },
    UPLOAD: {
        FILE: '/upload/file'
    },
    LOCATION: {
        PLACES: '/location/places'
    },
    BUREAU: {
        GET: '/bureau',
        UPDATE: '/bureau/update',
        VERIFY: '/bureau/verify'
    },
    BIO: {
        GENERATE: '/bio/generate'
    },
    BANNER: {
        GET: '/product-ads'
    }
};
